import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScheduleStatusBadgeProps } from '@modules/digital-signage/model/playlist-schedule.model.ts';
import { SCHEDULE_TIME_STATUS_CONFIG } from '@modules/digital-signage/utils/schedule-appearance.utils.ts';
import StatusLozenge from '@modules/digital-signage/components/group-settings/components/status-lozenge/status-lozenge.tsx';

const ScheduleStatusBadge: React.FC<ScheduleStatusBadgeProps> = ({
  status,
  className
}) => {
  const { t } = useTranslation();
  const { tone, label } = SCHEDULE_TIME_STATUS_CONFIG[status];

  return tone ? (
    <StatusLozenge tone={tone} label={t(label)} className={className} />
  ) : null;
};

export default ScheduleStatusBadge;
